'use client';

import { useAtom } from 'jotai';
import { useEffect } from 'react';

import { Search } from '@flipster/ui';

import { searchTextAtom } from '../jotai';

const GlossaryPageSearch = ({ className }: { className?: string }) => {
  const [searchText, setSearchText] = useAtom(searchTextAtom);

  useEffect(() => {
    const nextSearchParams = new URLSearchParams(window.location.search);
    if (nextSearchParams.get('search') === searchText) return;

    if (searchText) {
      nextSearchParams.set('search', searchText);
    } else {
      nextSearchParams.delete('search');
    }
    window.history.replaceState(null, '', `?${nextSearchParams}${window.location.hash}`);
  }, [searchText]);

  return (
    <Search
      className={className}
      value={searchText}
      placeholder='Search keyword'
      onChange={setSearchText}
      withClear
      autoFocus
    />
  );
};

export default GlossaryPageSearch;
